import React, { useState, useEffect } from 'react'
import {
  Box,
  Grid,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  InputAdornment,
  Dialog
} from "@mui/material";
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import ReportForm from "./ReportForm";
import axios from "../../../../utils/fvAxios";
import BaseURL from "../../../../utils/base-uri.json";
import Nodata from "../../../../pages/Nodata/Nodata";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton'
import { getToken, getOrgType } from '../../../../utils/Token';
import ReportView from './ReportView';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});




export default function OtherReports() {
  const [open, setOpen] = React.useState(false);
  const [token, setToken] = useState(getToken())

  const handleClickOpen = () => {
    setOpen(true);
  };
  const orgtype = getOrgType()
  const handleClose = () => {
    setOpen(false);
  };


  // Show = false only applicable for form(filter) reports,  true applicable for direct reports
  const Data = [
    {
      key: 1,
      value: "Expiring Documents",
      formsUrl: BaseURL?.baseReportUrl + "ExpiringDocumentWebForm.aspx",
      type: 3,
      Show: false
    },
    {
      key: 2,
      value: "Expired Documents",
      formsUrl: BaseURL?.baseReportUrl + "ExpiredDocumentWebForm.aspx",
      type: 17,
      Show: false
    },
    {
      key: 3,
      value: "Clients List",
      url: BaseURL?.baseReportUrl + "Clients.aspx",
      type: 2,
      Show: true
    },
    {
      key: 4,
      value: "Vendors By Submitted Date",
      url: BaseURL?.baseReportUrl + "VendorBySubmitted.aspx",
      type: 1,
      Show: true
    },
    {
      key: 5,
      value: "Locked Questionnaires",
      url: BaseURL?.baseReportUrl + "LockedTemplates.aspx",
      type: 0,
      Show: true
    },
    {
      key: 6,
      value: "Vendor Employee Training Summary",
      formsUrl: BaseURL?.baseReportUrl + 'VendorEmployeeTrainingsByName.aspx',
      type: 4,
      Show: false
    },
    {
      key: 7,
      value: "Subsection Report",
      formsUrl: BaseURL?.baseReportUrl + "SubSectionReport.aspx",
      type: 5,
      Show: false
    },
    {
      key: 8,
      value: "Onsite Offsite",
      formsUrl: BaseURL?.baseReportUrl + "OnsiteOffsiteVendorEmployees.aspx",
      type: 19,
      Show: false
    },
    {
      key: 9,
      value: "Onsite Visitors",
      formsUrl: BaseURL?.baseReportUrl + "ExpiredDocumentWebForm.aspx",
      type: 9,
      Show: false
    },
    {
      key: 10,
      value: "Onsite Offsite Client",
      formsUrl: BaseURL?.baseReportUrl + "OnsiteOffsiteClientEmployees.aspx",
      type: 18,
      Show: false
    },
    {
      key: 11,
      value: "Invitations Sent",
      formsUrl: BaseURL?.baseReportUrl + "InvitationsSent.aspx",
      type: 6,
      Show: false
    },
    {
      key: 12,
      value: "Contractor Evaluations",
      formsUrl: BaseURL?.baseReportUrl + "ScoreCardReviews.aspx",
      type: 7,
      Show: false
    },
    {
      key: 13,
      value: "Notifications",
      url: BaseURL?.baseReportUrl + "Notifications.aspx",
      type: 8,
      Show: true
    },
    {
      key: 14,
      value: "Injury Statistics",
      formsUrl: BaseURL?.baseReportUrl + "InjuryStatisticsReport.aspx",
      type: 9,
      Show: false
    },
    {
      key: 15,
      value: "Insurance Information",
      formsUrl: BaseURL?.baseReportUrl + "ExpiredDocumentWebForm.aspx",
      type: 10,
      Show: false
    },
    {
      key: 16,
      value: "Status History",
      formsUrl: BaseURL?.baseReportUrl + "StatusStatistics.aspx",
      type: 11,
      Show: false
    },
    {
      key: 17,
      value: "Fees Paid",
      formsUrl: BaseURL?.baseReportUrl + "ExpiredDocumentWebForm.aspx",
      type: 12,
      Show: false
    },
    {
      key: 18,
      value: "Sinepro CheckIn/CheckOut",
      formsUrl: BaseURL?.baseReportUrl + "SineproCheckinCheckOut.aspx",
      type: 20,
      Show: false
    },
    {
      key: 19,
      value: "Financial Analytics",
      formsUrl: BaseURL?.baseReportUrl + "ExpiredDocumentWebForm.aspx",
      type: 13,
      Show: false
    },
    {
      key: 20,
      value: "Vendor Contract Info",
      formsUrl: BaseURL?.baseReportUrl + "VendorContractInfo.aspx",
      type: 14,
      Show: false
    },
    {
      key: 21,
      value: "Multi-Client Prequalifications",
      formsUrl: BaseURL?.baseReportUrl + "ExpiredDocumentWebForm.aspx",
      type: 15,
      Show: false
    },
    {
      key: 23,
      value: "American Crystal Sugar Training Report",
      formsUrl: BaseURL?.baseReportUrl + "ExpiredDocumentWebForm.aspx",
      type: 23,
      Show: false
    },
    {
      key: 24,
      value: "Training Guide",
      formsUrl: BaseURL?.baseReportUrl + "ExpiredDocumentWebForm.aspx",
      type: 16,
      Show: false
    },
    {
      key: 25,
      value: "Luck Stone Report with MSHA ID",
      formsUrl: BaseURL?.baseReportUrl + "ExpiredDocumentWebForm.aspx",
      type: 29,
      Show: false
    },
    {
      key: 26,
      value: "Ormat PQ Report",
      formsUrl: BaseURL?.baseReportUrl + "OrmatALTPQDetails.aspx",
      type: 26,
      Show: false
    },
    {
      key: 27,
      value: "GPC Standard Report",
      formsUrl: BaseURL?.baseReportUrl + "VendorPQDetailsWithBiddings.aspx",
      type: 27,
      Show: false
    },
    {
      key: 28,
      value: "Client Uploads Report",
      formsUrl: BaseURL?.baseReportUrl + "ClientUploadsFromQuestionnaire.aspx",
      type: 28,
      Show: false
    },
    {
      key: 29,
      value: "Green Plains Active Safety Report",
      url: BaseURL?.baseReportUrl + "GPSafetyStatistics.aspx",
      type: 29,
      Show: true
    },
    {
      key: 30,
      value: "Green Plains Safety Metrics Report",
      url: BaseURL?.baseReportUrl + "GPSafetyStatisticsMetricsReport.aspx",
      type: 30,
      Show: false
    },
    {
      key: 31,
      value: "Vendor Contacts Report",
      url: BaseURL?.baseReportUrl + "PrayonContacts.aspx",
      type: 31,
      Show: true
    },
    {
      key: 32,
      value: "Documents Report",
      formsUrl: BaseURL?.baseReportUrl + "GetDocumentsforAllClients.aspx",
      type: 32,
      Show: false
    },
    {
      key: 33,
      value: "BlackListed Employees",
      url: BaseURL?.baseReportUrl + "BlackListedEmployees.aspx",
      type: 33,
      Show: true
    },
    {
      key: 34,
      value: "Vendors with Expiring Trainings",
      url: BaseURL?.baseReportUrl + "VendorsWithExpiringTrainings.aspx",
      type: 34,
      Show: true
    },
    {
      key: 35,
      value: "Expiring Vendors in next 31 days",
      url: BaseURL?.baseReportUrl + "ExpiringVendorsInNext31Days.aspx",
      type: 35,
      Show: true
    },
    {
      key: 36,
      value: "Expired Vendors",
      url: BaseURL?.baseReportUrl + "ExpiredVendors.aspx",
      type: 36,
      Show: true
    },
    {
      key: 37,
      value: "Documents Expiring Vendors",
      url: BaseURL?.baseReportUrl + "DocumentsExpiringVendors.aspx",
      type: 37,
      Show: true
    },
    {
      key: 38,
      value: "Vendor Key Responses",
      url: BaseURL?.baseReportUrl + "SIREVendorKeyResponses.aspx",
      type: 38,
      Show: true
    },
    {
      key: 39,
      value: "Vendor Contacts",
      url: BaseURL?.baseReportUrl + "SIREVendorContacts.aspx",
      type: 39,
      Show: true
    },
    {
      key: 40,
      value: "Employee Check-in History",
      formsUrl: BaseURL?.baseReportUrl + "EmployeeCheckInHistory.aspx",
      type: 40,
      Show: false
    },
    {
      key: 41,
      value: "Static Code Usage History",
      formsUrl: BaseURL?.baseReportUrl + "StaticCodeUsageHistory.aspx",
      type: 41,
      Show: false
    }


  ];


  const [open1, setOpen1] = React.useState(false);
  const [Type, setType] = React.useState();
  const [name, setName] = React.useState("");
  const [FormUrl, setFormURL] = React.useState("");
  const handleOpen = (e, form, type) => {
    const der = e ? false : true
    if (type == 23) { // type==24 to Type==23 
      setOpen(true);
      axios.get("Prequalification/GetExternalPowerBIReportDetails?reportID=4dec58a0-6c96-45f2-89d0-c3e6ca0bc83a"
      ).then((res) => {
        if (res?.data?.responseCode === 100) {

          setDetails(res?.data?.data?.value?.embedReports);
          setTokens(res?.data?.data?.value?.embedToken?.token);
        }
        else {
          setError(res.data.responseMessage);
          setOpen(true);
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        setIsLoading(false);
      });
    } else if (form) {
      setOpen1(der);
    }
  };
  const handleClose1 = () => {
    setOpen1(false);

  };
  const [filteredResults, setFilteredResults] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const searchItems = (searchValue) => {
    const lowerCaseSearchValue = searchValue.trim().toLowerCase();
    setSearchInput(lowerCaseSearchValue);

    if (lowerCaseSearchValue !== "") {
      const filteredData1 = filteredData?.filter((item) => {
        const ansLowerCase = item?.value.toLowerCase();
        return ansLowerCase.includes(lowerCaseSearchValue);
      });
      setFilteredResults(filteredData1);
    } else {
      setFilteredResults(Data);
    }
  };


  const [ReportsList, setReportsList] = React.useState([]);
  useEffect(() => {
    axios
      .get(
        "RolesAndPermissions/GetReportsMenuDetails"
      )
      .then((res) => {
        if (res.data.responseCode === 100) {
          setReportsList(res.data.data);
        } else {
          setError(res.data.responseMessage);
        }
      })
      .catch((err) => {
        console.log(err);
      }).finally(() => {
        setIsLoading(false);
      });
  }, []);
  const filteredData = Data.filter((report) => {
    const matchingReport = ReportsList?.find((r) => r.reportId == report.key);
    return matchingReport ? matchingReport.isVisible : false;
  });
  filteredData?.sort((a, b) => a.value.localeCompare(b.value));
  const [details, setDetails] = useState([]);
  const [tokens, setTokens] = useState("");
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);



  const openInNewTab = (url, type) => {
    if (url) {
      const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
      if (newWindow) newWindow.opener = null
    }
    else if (type == 23) {// type==24 to Type==23 
      axios.get("Prequalification/GetExternalPowerBIReportDetails?reportID=4dec58a0-6c96-45f2-89d0-c3e6ca0bc83a"
      ).then((res) => {
        if (res?.data?.responseCode === 100) {
          setDetails(res?.data?.data?.value?.embedReports);
          setTokens(res?.data?.data?.value?.embedToken?.token);
        }
        else {
          setError(res.data.responseMessage);
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        setIsLoading(false);
      });
    }
  }

  // Filter the Data array based on isVisible in data2


  return (

    <Box sx={{ padding: "5px", marginBottom: "10px" }}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Dialog
        open={open1}
        onClose={handleClose1}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "450px",
            },
          },
        }}
      >

        <ReportForm close={handleClose1} name={name} type={Type} url={FormUrl} />
      </Dialog>
      <Box
        border={orgtype === "Client" ? "" : 1}
        borderLeft={orgtype === "Client" ? "" : 1}
        borderRight={orgtype === "Client" ? "" : 1}
        borderColor={orgtype === "Client" ? "" : "#e4e7ec"}
        sx={{
          background: "#fff",
          paddingTop: orgtype === "Client" ? "" : "10px",
          paddingBottom: "10px",
          marginBottom: "20px",
          padding: orgtype === "Client" ? "" : "10px",
        }}
      >
        <TextField
          size="small"
          hidden={orgtype === "Client"}
          sx={{
            "& legend": { display: "none" },
            "& fieldset": { top: 0 },
            marginBottom: "20px"
          }}
          id="outlined-basic"
          variant="outlined"
          placeholder="search"
          onChange={(e) => searchItems(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchOutlinedIcon />
              </InputAdornment>
            )
          }}

        />
        <br hidden={orgtype === "Client"}
        />
        <Dialog
          fullScreen
          open={open}
          onClose={handleClose}
          TransitionComponent={Transition}
        >
          <AppBar sx={{ position: 'relative' }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          {details?.map((r, index) => (
            <a
              key={index}
              href={r.embedUrl} // Set the URL for the report here
              target="_blank" // Open in a new tab
              rel="noopener noreferrer" // Recommended for security
              style={{ textDecoration: 'none' }} // Remove underline
            >
              <PowerBIEmbed

                style={{ marginTop: 'none', height: '100%' }}
                embedConfig={{
                  type: 'report',
                  id: r.reportId,
                  embedUrl: r.embedUrl,
                  accessToken: tokens,
                  tokenType: models.TokenType.Embed,
                  settings: {
                    panes: {
                      filters: {
                        expanded: false,
                        visible: false,
                      },
                      bars: {
                        statusBar: {
                          visible: false,
                        },
                      },
                    },
                  },
                }}
                eventHandlers={
                  new Map([
                    ['loaded', function () { console.log('Report loaded'); }],
                    ['rendered', function () { console.log('Report rendered'); }],
                    ['error', function (event) { console.log(event.detail); }],
                  ])
                }
                cssClassName={'embed_container'}
                getEmbeddedComponent={(embeddedReport) => {
                  window.report = embeddedReport;
                }}
              />
            </a>
          ))}
        </Dialog>



        {/* {searchInput?.length > 1 ? (
          filteredResults?.length > 0 ? (
            filteredResults.map((r) => (
              <div key={r.key} style={{ marginBottom: "5px" }}>
                <a
                  target="_blank"
                  style={{ color: '#2A93DB', cursor: "pointer", textDecoration: "none" }}
                  onClick={() => {
                    openInNewTab(r?.url,r?.type)
                    handleOpen(r?.url, r.formsUrl,r?.type);
                    setName(r?.value)
                    setType(r?.type)
                    setFormURL(r?.formsUrl)
                  }}
                >
                  <InsertDriveFileOutlinedIcon /> {r.value}
                </a>
              </div>
            ))
          ) : (
            <div><Nodata/></div>
          )
        ) : (
          Data?.length > 0 ? (
            Data?.map((r) => (
              <div key={r.key} style={{ marginBottom: "5px" }}>
                <a
                  target="_blank"
                  style={{ color: '#2A93DB', cursor: "pointer", textDecoration: "none" }}
                  onClick={() => {
                    openInNewTab(r?.url,r?.type)
                    handleOpen(r?.url, r.formsUrl,r?.type);
                    setName(r?.value)
                    setType(r.type)
                    setFormURL(r?.formsUrl)
                  }}
                >
                  <InsertDriveFileOutlinedIcon /> {r.value}
                </a>
              </div>
            ))
          ) : (
            <div><Nodata/></div>
          )
        )} */}
        {searchInput?.length > 1 ? (
          filteredResults?.length > 0 ? (
            filteredResults.map((r) => (
              <div key={r.key} style={{ marginBottom: "5px" }}>
                <a
                  hidden={r?.Show}
                  target="_blank"
                  style={{ color: '#2A93DB', cursor: "pointer", textDecoration: "none" }}
                  onClick={() => {
                    openInNewTab(r?.url, r?.type)
                    handleOpen(r?.url, r.formsUrl, r?.type);
                    setName(ReportsList?.find((q) => q?.reportId == r?.key)?.reportName)
                    setType(r?.key)
                    setFormURL(r?.formsUrl)
                  }}
                >
                  <InsertDriveFileOutlinedIcon /> {ReportsList?.find((q) => q?.reportId == r?.key)?.reportName}
                </a>
                <div hidden={!r?.Show}>
                  <ReportView Url={r?.url} displayName={ReportsList?.find((q) => q?.reportId == r?.key)?.reportName} show={r?.Show} />
                </div>
              </div>
            ))
          ) : (
            <div><Nodata /></div>
          )
        ) : (
          filteredData?.length > 0 ? (
            filteredData.map((r) => (
              <div key={r.key} style={{ marginBottom: "5px" }}>
                <a
                  hidden={r?.Show}
                  target="_blank"
                  style={{ color: '#2A93DB', cursor: "pointer", textDecoration: "none" }}
                  onClick={() => {
                    openInNewTab(r?.url, r?.type)
                    handleOpen(r?.url, r.formsUrl, r?.type);
                    setName(ReportsList?.find((q) => q?.reportId == r?.key)?.reportName)
                    setType(r?.key)
                    setFormURL(r?.formsUrl)
                  }}
                >
                  <InsertDriveFileOutlinedIcon /> {ReportsList?.find((q) => q?.reportId == r?.key)?.reportName}
                </a>
                <div hidden={!r?.Show}>
                  <ReportView Url={r?.url} displayName={ReportsList?.find((q) => q?.reportId == r?.key)?.reportName} show={r?.Show} />
                </div>
              </div>
            ))
          ) : (
            <div hidden={isLoading}><Nodata /></div>
          )
        )}

      </Box>

    </Box>
  );
}